module.exports = __webpack_public_path__ + "static/media/boleto.25a4e888.svg";